import { render } from "./UnlikeIcon.vue?vue&type=template&id=58079282"
import script from "./UnlikeIcon.vue?vue&type=script&lang=js"
export * from "./UnlikeIcon.vue?vue&type=script&lang=js"
script.render = render

export default script